import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {ISolicitacaoItem} from "@models/solicitacoes/solicitacoes.ts";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {IFormaPagamento, IFormaPagamentoFormEntry} from "@models/formaPagamento/IFormaPagamento.ts";
import {IFormPagtoUpdateDto} from "@components/orcamento/models/IFormPagtoUpdateDto.ts";
import {IArquivo} from "@models/sistema/IArquivo.ts";
import {IAprovacao} from "@models/aprovacao/IAprovacao.ts";
import {OrcamentoAnexoType} from "@components/orcamento/CreateAnexoOrcamentoComponent.tsx";

export const __orcamento_endpoints = {
    v2: {
        ['get-orcamento']: (data: IDataNoPageDto<{ idOrcamento: number }>): IApiEndpoint<ISolicitacaoOrcamento> => {
            const {idOrcamento, ...rest} = data.data
            return {
                url: `/api/v2/orcamentos/${idOrcamento}`,
                method: 'GET',
                data: {...data, data: {...rest}},
            }
        },
        ['finaliza-orcamento']: (data: IDataNoPageDto<{
            idOrcamento: number
        }>): IApiEndpoint<ISolicitacaoOrcamento> => {
            return {
                url: `/api/v2/orcamentos/${data.data.idOrcamento}/finalizar`,
                method: 'POST',
                data: {...data, data: {}},
            }
        },
        ['autoriza-orcamento']: (data: IDataNoPageDto<{
            idOrcamento: number
        }>): IApiEndpoint<ISolicitacaoOrcamento> => {
            return {
                url: `/api/v2/orcamentos/${data.data.idOrcamento}/autorizar`,
                method: 'POST',
                data: {...data, data: {}},
            }
        },
        ['efetua-pagamento']: (data: IDataNoPageDto<{
            idOrcamento: number
        }>): IApiEndpoint<ISolicitacaoOrcamento> => {
            return {
                url: `/api/v2/orcamentos/${data.data.idOrcamento}/pagamento`,
                method: 'POST',
                data: {...data, data: {}},
            }
        },
        ['efetua-compra']: (data: IDataNoPageDto<{ idOrcamento: number }>): IApiEndpoint<ISolicitacaoOrcamento> => ({
            url: `/api/v2/orcamentos/${data.data.idOrcamento}/compra`,
            method: 'POST',
            data: {...data, data: {}},
        }),
        ['get-forma-pagamento']: (data: IDataNoPageDto<{
            idOrcamento: number,
            formIds?: number[]
        }>): IApiEndpoint<IFormaPagamento> => {
            const {idOrcamento, formIds, ...rest} = data.data
            return {
                url: `/api/v2/orcamentos/${idOrcamento}/forma-pagamento`,
                method: 'GET',
                data: {...data, data: {...rest}, query: {formIds}},
            }
        },
        ['get-forma-pagto-forms']: (data: IDataDto<{
            idOrcamento: number
        }>): IApiEndpoint<IFormaPagamentoFormEntry[]> => {
            const {idOrcamento, ...rest} = data.data
            return {
                url: `/api/v2/Orcamentos/${idOrcamento}/forma-pagamento/forms`,
                method: 'GET',
                data: {...data, data: {...rest}},
            }
        },
        ['update-forma-pagto-forms']: (data: IDataNoPageDto<IFormPagtoUpdateDto>): IApiEndpoint<IFormaPagamentoFormEntry[]> => {
            const {idOrcamento, forms} = data.data
            return {
                url: `/api/v2/Orcamentos/${idOrcamento}/pagamento/forms`,
                method: 'PATCH',
                data: {...data, data: [...forms]},
            }
        },
        ['get-arquivos']: (data: IDataDto<{
            idOrcamento: number,
            tipos?: OrcamentoAnexoType[]
        }>): IApiEndpoint<IArquivo[]> => {
            const {idOrcamento, tipos, ...rest} = data.data
            return {
                url: `/api/v2/Orcamentos/${idOrcamento}/arquivos`,
                method: 'GET',
                query: {tipos},
                data: {...data, data: {...rest}},
            }
        },
        ['get-aprovacoes']: (data: IDataNoPageDto<{ idOrcamento: number }>): IApiEndpoint<IAprovacao[]> => {
            const {idOrcamento, ...rest} = data.data
            return {
                url: `/api/v2/orcamentos/${idOrcamento}/aprovacoes`,
                method: 'GET',
            }
        },
        item: {
            ['get-item']: (data: IDataNoPageDto<{ idOrcamento: number }>): IApiEndpoint<ISolicitacaoItem> => {
                return {
                    url: `/api/v2/orcamentos/${data.data.idOrcamento}/item`,
                    method: 'GET',
                    data: {...data, data: {}},
                }
            },
        },

    }
}
